import React, { Component } from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import { greyScaleColors } from "../../../Globals/styles";
import EmployeeDragable from "./employeeDragable";

class EmployeeListView extends Component {
  getButtonContent = () => {
    return this.props.employee.initials;
  };
  render() {
    const { employee, index, setEmployeeIsDragging, onRemove } = this.props;
    return (
      <div style={styles.container}>
        <div>
          <div
            className="col-xs-10"
            onClick={this.click}
            style={styles.employeeName}
            title={employee.initials}
          >
            <EmployeeDragable
              employee={employee}
              index={index}
              getButtonContent={this.getButtonContent}
              setEmployeeIsDragging={setEmployeeIsDragging}
            />
            {employee.name} - {employee.initials}
          </div>
          <div
            className="col-xs-2"
            style={styles.hourButtonContainer}
            onClick={onRemove}
          >
            <i className="fa fa-times-circle" />
          </div>
        </div>
      </div>
    );
  }
}

var styles = {
  container: {
    textAlign: "center",
    lineHeight: "35px",
    marginTop: "12px",
  },
  employeeName: {
    textAlign: "left",
    padding: "0 5px 0 40px",
    backgroundColor: greyScaleColors.greyLighter,
    height: "40px",
    lineHeight: "40px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    borderTopLeftRadius: "2px",
    borderTopRightRadius: "0px",
    borderBottomRightRadius: "0px",
    borderBottomLeftRadius: "2px",
  },
  hourButtonContainer: {
    padding: "0",
    backgroundColor: greyScaleColors.greyLighter,
    height: "40px",
    cursor: "pointer",
    zIndex: 10,
  },
  button: {
    padding: "0",
    borderTopLeftRadius: "0",
    borderBottomLeftRadius: "0",
    borderTopRightRadius: "2px",
    borderBottomRightRadius: "2px",
  },
};
EmployeeListView.propTypes = {
  employee: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    initials: PropTypes.string.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  setEmployeeIsDragging: PropTypes.func.isRequired,
};
export default Radium(EmployeeListView);



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/EmployeeListView/employee.jsx